import React from "react";
import AttributeEditor from "../components/attribute_field";
import DynamicSnackbar from "../components/dynamic_snackbar";
import LoadingBackdrop from "../components/loading_backdrop";
import issueStateUpdateRequest from "../components/panel_update_helper";
import SkinsTable from "../components/skins_table";

class CharacterInfoPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dynamicSnackbar: {
        open: false,
        severity: null,
        message: null,
        url: null,
      },
      panelHeader: "",
      characterId: null,
      characterUuid: null,
      panels: [],
      charactersTable: {
        headers: [],
        values: [],
        urls: [],
      },
      characterSkinsTable: {
        headers: [],
        values: [],
        skinUrls: [],
        unlockStates: [],
        skinIds: [],
        updateRoute: "",
      },
    };
  }

  render() {
    return (
      <div className="panel server-panel">
        <LoadingBackdrop open={this.state.loading} />
        <DynamicSnackbar
          open={this.state.dynamicSnackbar.open}
          severity={this.state.dynamicSnackbar.severity}
          message={this.state.dynamicSnackbar.message}
          url={this.state.dynamicSnackbar.url}
          handleClose={() => {
            this.setState({
              dynamicSnackbar: { ...this.state.dynamicSnackbar, open: false },
            });
          }}
        />
        <h1>{this.state.panelHeader}</h1>
        {this.state.panels.map(this.renderAttributePanelSection)}
        <div className="panel-section">
          <h1>Character Skins</h1>
          <SkinsTable
            tableKey={this.state.characterSkinsTable.name}
            tableHeaders={this.state.characterSkinsTable.headers}
            tableRows={this.state.characterSkinsTable.values}
            skinUrls={this.state.characterSkinsTable.skinUrls}
            playerId={this.state.characterSkinsTable.playerId}
            characterId={this.state.characterId}
            unlockStates={this.state.characterSkinsTable.unlockStates}
            skinIds={this.state.characterSkinsTable.skinIds}
            assetDir={this.state.characterSkinsTable.assetDir}
            updateRoute={this.state.characterSkinsTable.updateRoute}
            onTableChange={this.handleTableChange}
          />
        </div>
      </div>
    );
  }

  renderAttributePanelSection = (panel, i) => {
    return (
      <div className="panel-section" key={"panelSection_" + i}>
        <h1>{panel.sectionName}</h1>
        {panel.attributes.map(this.renderAttribute)}
      </div>
    );
  };

  renderAttribute = (spec) => {
    return (
      <AttributeEditor
        key={spec.attributeId + spec.value}
        attributeId={spec.attributeId}
        label={spec.label}
        value={spec.value}
        type={spec.type}
        editable={spec.editable}
        onEdit={this.handleAttributeEdit}
      />
    );
  };

  async componentDidMount() {
    await issueStateUpdateRequest(
      this,
      "/character_info_panel/get_character_info/" +
        this.props.match.params.characterID
    );
  }

  handleAttributeEdit = async (url, attributeId, newValue) => {
    await issueStateUpdateRequest(
      this,
      "/character_info_panel/set_character_attribute",
      {
        characterUuid: this.state.characterUuid,
        attributeId: attributeId,
        value: newValue,
      },
      "post"
    );
  };

  handleTableChange = async () => {
    await issueStateUpdateRequest(
      this,
      "/character_info_panel/get_character_info/" +
        this.props.match.params.characterID
    );
  };
}

export default CharacterInfoPanel;
